// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./plugins/slicer_cli_web/web_client/stylesheets/controlsPanel.styl
// module id = 51
// module chunks = 0